import React from 'react'
import './index.scss'
import { useHistory } from "react-router-dom"
import { closeWebview } from '../../utils/common'

interface Props {
  title: string
  bgColor?: string
  className?: string
  iconUrl?: string
}

const NavBar = ({ title, bgColor, className, iconUrl }: Props) => {
  const bgColorStyle = !!bgColor ? { backgroundColor: bgColor } : {}
  const history = useHistory()

  const goBack = () => {
    if (history?.length === 1) {
      closeWebview()
      return
    }
    history.goBack()
  }

  return (
    <div className={`nav-bar-component ${ className ? className : '' }`} style={bgColorStyle}>
      <div className='bar'>
        <img alt='' src={require('./assets/back.png')} className='icon' onClick={goBack} />
        <span className='title'>{title}</span>
        {
          !!iconUrl ? <img alt='' src={iconUrl} className='icon' /> :
          <div className='icon'></div>
        }
      </div>
    </div>
  )
}

export default NavBar